import type React from 'react';
import type { ModalCloseClickLocation } from './components/consts';

export enum ModalType {
  PEEK_A_BOO = 'PEEK_A_BOO',
  // Docked to left side of screen, full screen on mobile
  DOCKED = 'DOCKED',
  // Standard modal on desktop, bottom sheet on mobile
  STANDARD = 'STANDARD',
  // Standard modal on desktop, full screen slide up on mobile
  FULL_SCREEN_MOBILE = 'FULL_SCREEN_MOBILE',
  // Full screen slide up on both mobile and tablet (centered card only on desktop). Use when the
  // modal owns its own footer (e.g. a Place Order bar rendered inside it).
  FULL_SCREEN_MOBILE_AND_TABLET = 'FULL_SCREEN_MOBILE_AND_TABLET',
  /**
   * Full screen slide up on mobile, a wide content-height centered card on tablet/desktop (capped
   * so tall content scrolls). Use when the desktop modal should hug its content rather than fill
   * the viewport height.
   */
  FULL_SCREEN_MOBILE_STANDARD_DESKTOP = 'FULL_SCREEN_MOBILE_STANDARD_DESKTOP',
  /**
   * Whole viewport at every breakpoint, no backdrop and no card, page underneath still mounted.
   * Content owns its own scrolling and max-width.
   */
  FULL_SCREEN = 'FULL_SCREEN',
}

export interface BaseProps {
  // add padding to bottom of modal when keyboard is open
  adjustForKeyboard?: boolean;
  isShowing: boolean;
  modalType?: ModalType;
}

export interface BaseModalProps extends BaseProps {
  onBackdropClick?: () => void;
  ariaLabel?: string;
  dialogRef?: React.RefObject<HTMLDivElement>;
  onDialogKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
}

export interface ModalProps extends BaseProps {
  onOutsideClick?: (clickLocation?: ModalCloseClickLocation) => void;
  preventExternalClose?: boolean;
  ariaLabel?: string;
  onClose?: (clickLocation: ModalCloseClickLocation) => void;
}
